import { IApplicationState } from 'shared/types/redux';
import { getCoworkingPageTitle } from 'shared/utils/getCoworkingPageTitle';

import { getCoworkingOperatorId } from '../coworking/selectors/dump/getCoworkingOperatorId';

export const getUserData = (state: IApplicationState) => {
  const {
    user,
    custom: { abGroup },
  } = state;

  const parsedAbGroup = abGroup ? parseInt(abGroup, 10) : 0;

  if (!user || !user.isAuthenticated || !user.id || !user.userId) {
    return {
      abGroup: parsedAbGroup,
      type: 'not_authorized',
    };
  }

  return {
    abGroup: parsedAbGroup,
    cianUserId: user.id,
    email: user.email || '',
    type: user.userType || '',
    userId: user.userId,
    tarif: user.tariff || '',
    balance: user.balance || 0,
  };
};

export const getCoworkingData = (state: IApplicationState) => {
  const { custom, coworking, gaData } = state;

  return {
    id: custom.coworkingId ? Number(custom.coworkingId) : 0,
    offerType: 'Coworking',
    objectType: 'CW',
    ownerId: getCoworkingOperatorId(state),
    ownerType: 'operator',
    position: 1,
    name: getCoworkingPageTitle(coworking),
    city_id: gaData?.cityId || 0,
  };
};

export const getOfferData = (state: IApplicationState, offerId: number) => {
  const { coworking, custom } = state;
  const offers = coworking?.offers || [];
  const currentOfferPosition = offers.findIndex(offer => offer.id === offerId);

  return {
    id: offerId,
    offerType: 'flexible_office',
    position: currentOfferPosition > -1 ? currentOfferPosition + 1 : 0,
    extra: {
      parentId: custom.coworkingId ? Number(custom.coworkingId) : 0,
    },
  };
};

export const getPageData = (state: IApplicationState) => {
  const {
    custom: { offerId, coworkingId },
  } = state;

  return {
    pageType: 'CardCW',
    siteType: 'desktop',
    offerId: offerId || coworkingId,
  };
};

export const getTrackOpenPageData = (state: IApplicationState) => {
  return {
    page: getPageData(state),
    products: [getCoworkingData(state)],
    user: getUserData(state),
  };
};
